export default __webpack_public_path__ + "static/media/TX-img.72fca11a.svg";